import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import P11AdminLayout from "./P11AdminLayout";
import { P11 } from "./p11shared";

// Admin-only statistieken. Nooit zichtbaar voor deelnemers/publiek.
export default function P11AdminOverview() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/project11/admin/overview").then(({ data }) => setData(data)).catch(() => setData(false)); }, []);
  if (!data) return <P11AdminLayout><span className="p11-label">…</span></P11AdminLayout>;
  const e = data.enrollments;
  const cards = [
    ["TOTAL REGISTRATIONS", (e.CONFIRMED || 0) + (e.WAITLISTED || 0) + (e.CANCELLED || 0) + (e.NOT_ENROLLED || 0) + (data.accounts_pending_verification || 0)],
    ["CONFIRMED PARTICIPANTS", e.CONFIRMED || 0],
    ["ACTIVE PARTICIPANTS", e.CONFIRMED || 0],
    ["WAITLISTED PARTICIPANTS", e.WAITLISTED || 0],
    ["CANCELLED PARTICIPANTS", e.CANCELLED || 0],
    ["PENDING EMAIL VERIFICATION", data.accounts_pending_verification || 0],
    ["TOTAL VERIFIED STAMPS", data.verified_stamps || 0],
    ["COMPLETED PARTICIPANTS", e.COMPLETED || 0],
    ["INCOMPLETE PARTICIPANTS", e.INCOMPLETE || 0],
    ["PROJECT CAPACITY", data.edition.project_capacity],
    ["CONFIRMED PLACES", data.edition.confirmed_count],
  ];
  return (
    <P11AdminLayout>
      <div data-testid="p11-admin-overview">
        <div className="p11-label-yellow">OVERVIEW</div>
        <h1 className="p11-h1 text-3xl mt-4 mb-8">STATISTICS.</h1>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-px" style={{ background: P11.border }} data-testid="p11-admin-stats">
          {cards.map(([label, value]) => (
            <div key={label} className="p-6" style={{ background: P11.bg }} data-testid={`p11-stat-${label.toLowerCase().replace(/ /g, "-")}`}>
              <div className="p11-mono text-3xl" style={{ color: P11.yellow }}>{value}</div>
              <div className="p11-label mt-3">{label}</div>
            </div>
          ))}
        </div>
        <div className="mt-10">
          <div className="p11-label mb-4">// SESSION METRICS</div>
          <div className="divide-y" style={{ borderColor: P11.border }}>
            {data.sessions.map((s) => (
              <div key={s.id} className="py-3 flex items-center justify-between" data-testid={`p11-stat-session-${s.number}`}>
                <span className="p11-label">SESSIE {String(s.number).padStart(2, "0")} · {s.date}</span>
                <span className="p11-label" style={{ color: P11.gray2 }}>{s.reserved_count}/{s.capacity} RESERVED</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </P11AdminLayout>
  );
}
